import type { Action } from "../types";

export function getEmbedContext(search: string, pathname = window.location.pathname) {
  const params = new URLSearchParams(search);
  const embedded = params.get("embed") === "1" || pathname === "/embed/actions";
  return {
    embedded,
    ticketKey: embedded ? params.get("ticket") || "" : "",
  };
}

export function actionsForEmbeddedTicket(actions: Action[], ticketKey: string) {
  if (!ticketKey) return [];
  return actions.filter((action) => action.ticket_key === ticketKey && !action.completed_at);
}

export function embeddedActionUrl(ticketKey: string, newAction = false) {
  const params = new URLSearchParams({ ticket: ticketKey });
  if (newAction) {
    params.set("view", "actions");
    params.set("newAction", "1");
    return `/?${params.toString()}`;
  }
  return `/embed/actions?${params.toString()}`;
}
